import initDataManager from './data-manager';
import ServiceLocator from "../../../../global/service-locator";

export default class CourseStats {
	constructor(props = {}) {
		this.$root = document.getElementById('courseStats');
		this.$spinner = this.$root.querySelector('.course-stats_spinner');
		this.$content = this.$root.querySelector('.course-stats_content');
		this.$bottomContainer = this.$root.querySelector('.course-stats_bottom');
		this.$length = document.getElementById('courseStatsLength');
		this.$frequency = document.getElementById('courseStatsFrequency');
		this.$start = document.getElementById('courseStatsStart');
		this.$lastWeek = document.getElementById('courseStatsLastWeek');
		this.$placesLeft = document.getElementById('courseStatsPlacesLeft');
		this.$programmeStats = document.querySelector('.programme-stats');
		this.$introductionSidebar = document.querySelector('.introduction-sidebar');
		this.$priceWidget = document.querySelector('.introduction-sidebar-widget.-price');
		this.$moneyTerms = document.getElementById('courseStatsMoneyTerms');
		this.$pricePartsValue = document.getElementById('courseStatsPricePartsValue');
		this.$priceUpfrontDiscount = this.$introductionSidebar.querySelector('.money-term.-upfront-discount');
		this.$priceUpfrontDiscountValue = document.getElementById('courseStatsDiscountUpfrontValue');
		this.$priceInitial = document.querySelector('.money-term.-initial');
		this.$priceInitialValue = document.getElementById('courseStatsPriceInitialValue');
		this.$priceFinalValue = document.getElementById('courseStatsPriceFinalValue');
		this.$pricePromocode = this.$introductionSidebar.querySelector('.money-term.-promocode');
		this.$pricePromocodeValue = document.getElementById('courseStatsPricePromocodeValue');
		this.$priceAppliedDiscounts = this.$introductionSidebar.querySelector('.money-term.-applied-discounts');
		this.$priceAppliedDiscountsValue = document.getElementById('courseStatsPriceAppliedDiscountsValue');
		this.$priceBalanceWriteOff = this.$introductionSidebar.querySelector('.money-term.-write-off');
		this.$priceBalanceWriteOffValue = document.getElementById('courseStatsPriceWriteOffValue');
		this.$priceFrozenMoneyWriteOff = this.$introductionSidebar.querySelector('.money-term.-main-balance-write-off');
		this.$priceFrozenMoneyWriteOffValue = document.getElementById('courseStatsPriceFrozenMoneyWriteOffValue');
		this.$priceMainBalanceWriteOff = this.$introductionSidebar.querySelector('.money-term.-frozen-money-write-off');
		this.$priceMainBalanceWriteOffValue = document.getElementById('courseStatsPriceMainBalanceWriteOffValue');
		this.$priceReferralBalanceWriteOff = this.$introductionSidebar.querySelector('.money-term.-referral-balance-write-off');
		this.$priceReferralBalanceWriteOffValue = document.getElementById('courseStatsPriceReferralBalanceWriteOffValue');
		this.$priceBonusBalanceWriteOff = this.$introductionSidebar.querySelector('.money-term.-bonus-balance-write-off');
		this.$priceBonusBalanceWriteOffValue = document.getElementById('courseStatsPriceBonusBalanceWriteOffValue');
		// this.$buyLink = document.getElementById('courseStatsBuyLink');

		this.$oldPriceValue = document.getElementById('courseStatsPriceOldValue');

		this.sl = ServiceLocator.instance;
		this.dataManager = initDataManager();

		this.onDataLoaded = props.onDataLoaded;
		this._fetchData = this.fetchData.bind(this);

		this.init();
	}

	init() {
		if (!this.$root) {
			throw new Error('CourseStats: Root element is not defined');
		}

		if (this.sl.userDataService.lmsUserDataLoaded) {
			this.fetchData();
		}

		window.addEventListener(this.sl.userDataService.LMS_USER_DATA_LOADED_EVENT, this._fetchData);
	}

	fetchData() {
		this.dataManager.fetch(() => {
			this.bootstrap();
		});
	}

	bootstrap() {
		if (this.$spinner) {
			this.$spinner.remove();
		}

		this.setAll();
		this.$introductionSidebar.classList.remove('-loading');

		if (this.$priceWidget && this.sl.userDataService.lmsUserData) {
			// TODO: remove this after awhile, due to the new checkout
			// if (!this.checkIsQuizPassedParamSet()) {
			// 	window.addEventListener('SET_QUIZ_PASSED_ON_BUY_LINK', () => {
			// 		if (this.checkIsQuizPassedParamSet()) {
			// 			return;
			// 		}
			//
			// 		this.$buyLink.href = Api.setQueryParams(this.$buyLink.href, { quiz: 1 });
			// 	});
			// }

			if (this.$oldPriceValue && !this.dataManager.priceLMS) {
				this.$oldPriceValue.classList.remove('-hidden');
			}
		}

		if (this.onDataLoaded) {
			this.onDataLoaded();
		}

		if (this.dataManager.priceLMS.limitlessBonuses) {
			this.$introductionSidebar.classList.add('-gift-bonuses');
		}
	}

	setAll() {
		this.setLength();
		this.setFrequency();
		this.setStart();
		this.setLastWeek();
		this.setPlacesLeft();

		if (this.$priceWidget) {
			this.setPriceWidget();
		}

		this.showContent();
	}

	setLength() {
		if (!this.$length) {
			return;
		} else if (!this.dataManager.lengthText) {
			this.$length.remove();
			return;
		}

		const $text = this.$length.querySelector('.course-stats_value');

		if ($text) {
			$text.textContent = this.dataManager.lengthText;
		}

		if (this.$programmeStats) {
			const $programmeStatsText = this.$programmeStats.querySelector('.programme-stats_info');
			$programmeStatsText.textContent = this.dataManager.lengthText;
			this.$programmeStats.classList.add('-show');
		}
	}

	setFrequency() {
		if (!this.$frequency) {
			return;
		} else if (!this.dataManager.frequencyText) {
			this.$frequency.remove();
			return;
		}

		const $text = this.$frequency.querySelector('.course-stats_value');

		if ($text) {
			$text.textContent = this.dataManager.frequencyText;
		}
	}

	setStart() {
		if (!this.$start) {
			return;
		} else if (!this.dataManager.startDateText) {
			this.$start.remove();
			return;
		}

		const $text = this.$start.querySelector('.course-stats_value');

		if ($text) {
			$text.innerHTML = this.dataManager.startDateText;
		}
	}

	setLastWeek() {
		if (!this.$lastWeek) {
			return;
		} else if (!this.dataManager.lastWeekTextObj) {
			this.$lastWeek.remove();
			return;
		}

		this.$lastWeek.querySelector('.course-stats_label').textContent = this.dataManager.lastWeekTextObj.label;
		this.$lastWeek.querySelector('.course-stats_value').textContent = this.dataManager.lastWeekTextObj.value;
	}

	setPlacesLeft() {
		if (!this.$placesLeft) {
			return;
		} else if (!this.dataManager.placesLeftText) {
			this.$placesLeft.remove();
			return;
		}

		this.$placesLeft.querySelector('.course-stats_value').textContent = this.dataManager.placesLeftText;
	}

	setPriceWidget() {
		this.setPriceParts();
		this.setInitialPrice();
		this.setUpfrontDiscount();
		this.setFinalPrice();
		this.setPromocode();
		this.setAppliedDiscounts();
		this.setBalanceWriteOff();
		this.setFrozenMoneyWriteOff();
		this.setMainBalanceWriteOff();
		this.setReferralBalanceWriteOff();
		this.setBonusBalanceWriteOff();
		// this.setQuizPassed();
	}

	setPriceParts() {
		if (!this.dataManager.pricePartsText) {
			return;
		}

		this.$pricePartsValue.textContent = this.dataManager.pricePartsText;
	}

	setInitialPrice() {
		if (!this.dataManager.initialPriceText) {
			return;
		}

		this.$priceInitialValue.textContent = this.dataManager.initialPriceText;
		this.$priceInitial.classList.remove('-hidden');
	}

	setUpfrontDiscount() {
		if (!this.$priceUpfrontDiscount) {
			return;
		}

		if (!this.dataManager.upfrontDiscountText) {
			this.$priceUpfrontDiscount.classList.add('-hidden');
			return;
		}

		this.$priceUpfrontDiscountValue.textContent = this.dataManager.upfrontDiscountText;
		this.$priceUpfrontDiscount.classList.remove('-hidden');
	}

	setPromocode() {
		if (!this.dataManager.promocodeText) {
			this.$pricePromocode.classList.add('-hidden');

			return;
		}

		this.$pricePromocodeValue.textContent = this.dataManager.promocodeText;
		this.$pricePromocode.classList.remove('-hidden');
	}

	setAppliedDiscounts() {
		if (!this.dataManager.appliedDiscountsText) {
			this.$priceAppliedDiscounts.classList.add('-hidden');
			return;
		}

		this.$priceAppliedDiscountsValue.textContent = this.dataManager.appliedDiscountsText;
		this.$priceAppliedDiscounts.classList.remove('-hidden');
	}

	setBalanceWriteOff() {
		if (!this.dataManager.writeOffText) {
			this.$priceBalanceWriteOff.classList.add('-hidden');
			return;
		}

		this.$priceBalanceWriteOffValue.textContent = this.dataManager.writeOffText;
		this.$priceBalanceWriteOff.classList.remove('-hidden');
	}

	setFrozenMoneyWriteOff() {
		if (!this.dataManager.frozenMoneyWriteOffText) {
			this.$priceFrozenMoneyWriteOff.classList.add('-hidden');
			return;
		}

		this.$priceFrozenMoneyWriteOffValue.textContent = this.dataManager.frozenMoneyWriteOffText;
		this.$priceFrozenMoneyWriteOff.classList.remove('-hidden');
	}

	setMainBalanceWriteOff() {
		if (!this.dataManager.mainBalanceWriteOffText) {
			this.$priceMainBalanceWriteOff.classList.add('-hidden');
			return;
		}

		this.$priceMainBalanceWriteOffValue.textContent = this.dataManager.mainBalanceWriteOffText;
		this.$priceMainBalanceWriteOff.classList.remove('-hidden');
	}

	setReferralBalanceWriteOff() {
		if (!this.dataManager.referralBalanceWriteOffText) {
			this.$priceReferralBalanceWriteOff.classList.add('-hidden');
			return;
		}

		this.$priceReferralBalanceWriteOffValue.textContent = this.dataManager.referralBalanceWriteOffText;
		this.$priceReferralBalanceWriteOff.classList.remove('-hidden');
	}

	setBonusBalanceWriteOff() {
		if (!this.dataManager.bonusBalanceWriteOffText) {
			this.$priceBonusBalanceWriteOff.classList.add('-hidden');
			return;
		}

		this.$priceBonusBalanceWriteOffValue.textContent = this.dataManager.bonusBalanceWriteOffText;
		this.$priceBonusBalanceWriteOff.classList.remove('-hidden');
	}

	setFinalPrice() {
		if (!this.dataManager.finalPriceText) {
			return;
		}

		this.$priceFinalValue.textContent = this.dataManager.finalPriceText;
		this.$priceFinalValue.classList.remove('-hidden');
	}

	// TODO: remove this after awhile, due to the new checkout
	// setQuizPassed() {
	// 	if (!this.sl.userDataService.lmsUserData || !craft.page.quiz.items || !craft.page.quiz.items.length || this.checkIsQuizPassedParamSet()) {
	// 		return;
	// 	}
	//
	// 	let quizEntryId = craft.page.quiz.items[0].entryId;
	//
	// 	if (!quizEntryId) {
	// 		return;
	// 	}
	//
	// 	let quizData = localStorage.getItem(`${document.documentElement.lang}_quiz_${craft.page.courseDirectoryId}`);
	//
	// 	if (!quizData && document.documentElement.lang === 'uk') {
	// 		quizData = localStorage.getItem(`ru_quiz_${craft.page.courseDirectoryId}`);
	// 	} else if (!quizData && document.documentElement.lang === 'ru') {
	// 		quizData = localStorage.getItem(`uk_quiz_${craft.page.courseDirectoryId}`);
	// 	}
	//
	// 	if (quizData) {
	// 		quizData = JSON.parse(quizData);
	// 	}
	//
	// 	if (!quizData || !quizData[quizEntryId] || !quizData[quizEntryId]['result'] || quizData[quizEntryId]['result'] === 'poor') {
	// 		return;
	// 	}
	//
	// 	this.$buyLink.href = Api.setQueryParams(this.$buyLink.href, { quiz: 1 });
	// }

	// TODO: remove this after awhile, due to the new checkout
	// checkIsQuizPassedParamSet() {
	// 	const splitted = this.$buyLink.href.split('?');
	//
	// 	return splitted.length !== 1 && splitted[1].includes('quiz=1');
	// }

	showContent() {
		if (this.$priceWidget && this.$moneyTerms.children.length === 2) {
			this.$priceInitial.classList.add('-hidden');
		}

		if (
			(!this.dataManager.lastWeekTextObj) &&
			(!this.dataManager.placesLeftText)
		) {
			this.$root.classList.add('-top-only');
			this.$introductionSidebar.classList.add('-top-only');
		} else {
			if (!this.dataManager.lastWeekTextObj) {
				this.$placesLeft.classList.add('-without-dot');
			}

			this.$root.classList.add('-show');
		}
	}
}